import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Save, FileText, ExternalLink, Image, Upload } from "lucide-react";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
import ImageGalleryModal from "./ImageGallery/ImageGalleryModal";
import axios from "axios";
import { baseUrl } from "../../Constants";

const icons = [
  "images/Home/Recent/recent-update-icon-databricks-new.png",
  "images/Home/Recent/recent-update-icon-accenture-new.png",
  "images/Home/Recent/recent-update-icon-genai-new-latest.png",
  "images/Home/Recent/recent-update-icon-nividia-new.png",
  "images/Home/Recent/recent-update-icon-dfa-new.png",
  "images/Home/Recent/recent-update-icon-dast.png",
  "images/Home/Recent/recent-update-icon-wiremock-new.png",
  "images/Home/Recent/recent-update-icon-nextgen.png",
  "images/Home/Recent/recent-update-icon-emea.png",
  "images/Home/Recent/recent-update-icon-bdd-cucumber.png",
];

// Custom validation functions
const validateTitle = (value) => {
  if (!value) return "Title is required";
  if (value.length < 3) return "Title must be at least 3 characters";
  if (value.length > 100) return "Title must be less than 100 characters";
  return true;
};

const validateDescription = (value) => {
  if (!value) return "Description is required";
  if (value.length < 20) return "Description must be at least 20 characters";
  if (value.length > 400) return "Description must be less than 400 characters";
  return true;
};

const validateLink = (value) => {
  // if (!value) return 'Link is required';
  if (value) {
    try {
      new URL(value);
      return true;
    } catch {
      return "Please enter a valid URL";
    }
  } else {
    return true;
  }
};

const validateIcon = (value) => {
  if (!value) return "Icon path is required";
  return true;
};

const axiosPostCall = async (data, getRecentUpdateData) => {
  console.log("thisss one", data.title);

  try {
    const res = await axios.post(`${baseUrl}/addrecentupdate`, data, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    });
    getRecentUpdateData();
  } catch (err) {
    console.error(err);
  }
};

const axiosUpdateCall = async (data, id, getRecentUpdateData) => {
  console.log("update", data);

  try {
    const res = await axios.post(
      `${baseUrl}/updaterecentupdate`,
      { ...data, id },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    );
    getRecentUpdateData();
  } catch (err) {
    console.error(err);
  }
};

const AddRecentUpdates = ({
  onSubmit = (data) => {
    console.log("data on submit", data);

    if (item) {
      axiosUpdateCall(data, item.id, getRecentUpdateData);
    } else {
      axiosPostCall(data, getRecentUpdateData);
    }
    setaddRecentUpdatePopup(false);
  },
  initialData,
  setaddRecentUpdatePopup,
  item,
  getRecentUpdateData,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
    setValue,
  } = useForm({
    defaultValues: initialData || {
      title: "",
      description: "",
      link: "",
      icon: "",
    },
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const watchedDescription = watch("description", "");

  const onFormSubmit = async (data) => {
    try {
      await onSubmit(data);
      // Optional: Reset form after successful submission
      // reset();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleImageSelect = (src) => {
    setSelectedImage(src);
    setValue("icon", src, { shouldValidate: true });
  };

  useEffect(() => {
    register("icon", { validate: validateIcon });
  }, [register]);

  useEffect(() => {
    console.log("edititem received", item);

    if (item) {
      handleImageSelect(item.icon);
      setValue("title", item.title);
      setValue("description", item.description);
      setValue("link", item.link);
    }
  }, []);

  return (
    <>
      <div className="form-container">
        <div className="form-header">
          <h2 className="form-title">Add Recent Update</h2>
          <div className="form-description">
            Create a new recent update entry with all required details.
          </div>
        </div>

        <form onSubmit={handleSubmit(onFormSubmit)} className="form">
          <div className="split-form">
            <div className="form-column">
              {/* Title */}
              <div className="field-group">
                <label htmlFor="title" className="field-label">
                  <FileText className="field-icon" />
                  Update Title
                </label>
                <input
                  {...register("title", { validate: validateTitle })}
                  type="text"
                  id="title"
                  placeholder="e.g., NVIDIA Knowledge Quest Foundation Program"
                  className={`field-input ${errors.title ? "error" : ""}`}
                  aria-label="title"
                  default={item ? item.title : ""}
                />
                {errors.title && (
                  <div className="error-message">
                    <span className="error-dot"></span>
                    {errors.title.message}
                  </div>
                )}
              </div>

              {/* Description */}
              <div className="field-group">
                <label
                  htmlFor="description"
                  className="field-label-with-counter"
                >
                  <span className="field-label">
                    <FileText className="field-icon" />
                    Update Description
                  </span>
                  <span className="character-counter">
                    {watchedDescription.length}/400
                  </span>
                </label>
                <textarea
                  {...register("description", {
                    validate: validateDescription,
                  })}
                  id="description"
                  rows={4}
                  placeholder="An engaging and exciting Quiz Series on the NVIDIA Knowledge Quest Foundation Program..."
                  className={`field-textarea ${
                    errors.description ? "error" : ""
                  }`}
                  default={item ? item.description : ""}
                />
                {errors.description && (
                  <div className="error-message">
                    <span className="error-dot"></span>
                    {errors.description.message}
                  </div>
                )}
              </div>
            </div>
            <div className="form-column">
              {/* Link */}
              <div className="field-group">
                <label htmlFor="link" className="field-label">
                  <ExternalLink className="field-icon" />
                  Update Link
                </label>
                <input
                  {...register("link", { validate: validateLink })}
                  type="url"
                  id="link"
                  placeholder="https://wd103.myworkday.com/accenture/learning/course/..."
                  className={`field-input ${errors.link ? "error" : ""}`}
                  aria-label="link"
                  default={item ? item.know_more_url : ""}
                />
                {errors.link && (
                  <div className="error-message">
                    <span className="error-dot"></span>
                    {errors.link.message}
                  </div>
                )}
              </div>

              {/* Image Gallery */}
              {/* Featured Icon Path */}
              <div className="field-group">
                <label htmlFor="icon" className="field-label">
                  <Upload className="field-icon" />
                  Icon Path
                </label>
                {/* <input
                                {...register('featuredicon', { validate: validateFeaturedIcon })}
                                type="text"
                                id="featuredicon"
                                placeholder="e.g., images/Home/ATCI SAP T20.png"
                                className={`field-input ${errors.featuredicon ? 'error' : ''}`}
                                aria-label="icon"
                            /> */}

                <div>
                  {selectedImage && (
                    <img
                      src={selectedImage}
                      alt="Selected"
                      style={{ width: 100 }}
                    />
                  )}
                  <button
                    className="choose-image-btn"
                    type="button"
                    onClick={() => setIsModalOpen(true)}
                  >
                    Choose Image
                  </button>
                </div>

                {errors.icon && (
                  <div className="error-message">
                    <span className="error-dot"></span>
                    {errors.icon.message}
                  </div>
                )}
              </div>

              <ImageGalleryModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSelect={handleImageSelect}
                images={icons}
              />
            </div>
          </div>

          {/* Submit Button */}
          <div className="button-group-addevent">
            <button
              type="submit"
              disabled={isSubmitting}
              className="submit-button"
            >
              {isSubmitting ? (
                <>
                  <div className="loading-spinner"></div>
                  Saving...
                </>
              ) : (
                <>
                  <Save className="button-icon" />
                  Save Update
                </>
              )}
            </button>

            <button
              type="button"
              onClick={() => setaddRecentUpdatePopup(false)}
              className="cancel-button"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddRecentUpdates;
